import { render, staticRenderFns } from "./AdminBookingsResult.vue?vue&type=template&id=2efd8a1a"
import script from "./AdminBookingsResult.vue?vue&type=script&lang=js"
export * from "./AdminBookingsResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports